import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import React, { FC } from "react";

interface Props extends WidgetProps {}

const ContactUsReCaptcha: FC<Props> = () => {
    return <ReCaptcha location="ContactUs" />;
};

const widgetModule: WidgetModule = {
    component: ContactUsReCaptcha,
    definition: {
        group: "Contact Us",
        displayName: "ReCaptcha",
        icon: "input-pipe",
        fieldDefinitions: [],
    },
};

export default widgetModule;
